var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var controlButtonClasses = [
    'tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-overflow-hidden tw-relative',
    'tw-w-8 tw-h-8 tw-text-gray-600 dark:tw-text-white/70 tw-border-0 tw-bg-transparent tw-rounded-full tw-transition-colors tw-duration-200 tw-ease-in-out',
    'hover:tw-text-gray-700 dark:hover:tw-text-white/80 hover:tw-border-transparent hover:tw-bg-gray-200 dark:hover:tw-bg-zinc-600',
];
var focusRingClasses = 'focus:tw-outline-none focus:tw-outline-offset-0 focus:tw-ring focus:tw-ring-primary-400/50 dark:focus:tw-ring-primary-300/50';
var hoverBgGrayClasses = 'hover:tw-bg-gray-100 dark:hover:tw-bg-gray-600/80';
var primarySelectedClasses = 'tw-text-white tw-bg-primary-500 hover:tw-bg-primary-600';
var timeUnitContainer = 'tw-flex tw-items-center tw-flex-col tw-px-1.5';
var baseSelectClasses = [
    'tw-text-base tw-leading-[normal]',
    'tw-font-semibold',
    'tw-text-gray-700 dark:tw-text-white/80',
    'tw-transition tw-duration-200',
    'tw-p-2',
    'tw-m-0',
    'hover:tw-text-primary-500 dark:hover:tw-text-primary-400',
    'tw-cursor-pointer',
];
var disabledTextCursor = 'tw-opacity-60 tw-cursor-default';
function dateCellClasses(context) {
    var _a, _b;
    return [
        'tw-inline-flex tw-items-center tw-justify-center',
        'tw-w-1/3',
        'tw-p-2',
        'tw-rounded-md',
        { 'tw-text-gray-600 dark:tw-text-white/70 tw-bg-transparent': !context.selected && !context.disabled },
        (_a = {}, _a[primarySelectedClasses] = context.selected && !context.disabled, _a),
        focusRingClasses,
        (_b = {},
            _b[hoverBgGrayClasses] = !context.selected && !context.disabled,
            _b['hover:tw-bg-highlight-emphasis'] = context.selected && !context.disabled,
            _b),
        'tw-cursor-pointer',
    ];
}
export default {
    root: function (_a) {
        var props = _a.props;
        return ({
            class: [
                { 'tw-flex': props.fluid, 'tw-inline-flex': !props.fluid },
                'tw-max-w-full tw-w-full',
                'tw-relative',
                'tw-min-h-8.5',
                { 'tw-opacity-60 tw-select-none tw-pointer-events-none tw-cursor-default': props.disabled },
            ],
        });
    },
    pcInputText: function (_a) {
        var props = _a.props;
        return ({
            root: {
                class: [
                    'tw-m-0 tw-outline-0 focus:tw-outline-0 tw-outline-transparent tw-block tw-w-full tw-rounded-md tw-border-0 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-gray-400 sm:tw-leading-6 dark:tw-bg-zinc-500 dark:tw-text-gray-100 dark:tw-ring-0 dark:tw-autofill:bg-zinc-600 focus:tw-ring-2 focus:tw-outline-none focus:tw-border-0 dark:focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-primary-500 tw-px-3 tw-py-0.5 tw-text-base sm:tw-text-md',
                    { 'tw-border-r-0 tw-rounded-r-none': props.showIcon },
                    { 'tw-cursor-pointer': !props.manualInput },
                ],
            },
        });
    },
    dropdownIcon: {
        class: ['tw-absolute tw-top-[50%] -tw-mt-2', 'tw-text-white dark:tw-text-gray-200', 'tw-right-[.75rem]'],
    },
    dropdown: {
        class: [
            'tw-inline-flex tw-items-center tw-justify-center',
            ' tw-py-1.5 tw-px-3 tw-rounded-r-md tw-cursor-pointer tw-text-center',
            'tw-border tw-border-l-0 tw-border-primary-500',
            'tw-transition tw-duration-200 tw-ease-in-out',
            primarySelectedClasses + ' dark:hover:tw-border-primary-600',
            focusRingClasses,
            'tw-relative tw-w-10',
            'tw-rounded-r-md',
        ],
    },
    inputIconContainer: 'tw-absolute tw-cursor-pointer tw-top-1/2 tw-right-3 -tw-mt-3',
    inputIcon: 'tw-inline-block tw-text-base',
    panel: function (_a) {
        var props = _a.props;
        return ({
            class: [
                { 'tw-absolute': !props.inline, 'tw-inline-block': props.inline },
                { 'tw-w-auto tw-w-fit tw-p-2': !props.inline },
                { 'tw-p-2 tw-min-w-full': props.inline },
                'tw-border tw-rounded-lg',
                { 'tw-shadow-md': !props.inline },
                'tw-bg-white dark:tw-bg-gray-800',
                'tw-border-gray-200 dark:tw-border-gray-700',
                { 'tw-overflow-x-auto': props.inline },
            ],
        });
    },
    header: {
        class: [
            'tw-font-semibold',
            'tw-flex tw-items-center tw-justify-between',
            'tw-p-2',
            'tw-m-0',
            'tw-border-b',
            'tw-rounded-t-md',
            'tw-text-gray-700 dark:tw-text-white/80',
            'tw-bg-gray-0 dark:tw-bg-gray-800',
            'tw-border-gray-200 dark:tw-border-gray-700',
        ],
    },
    title: { class: ['tw-leading-8', 'tw-mx-auto tw-my-0'] },
    selectMonth: { class: __spreadArray(__spreadArray([], __read(baseSelectClasses), false), ['tw-mr-2'], false) },
    selectYear: { class: baseSelectClasses },
    table: { class: ['tw-text-base tw-leading-none', 'tw-border-collapse', 'tw-w-full', 'tw-m-0 tw-my-2'] },
    tableHeaderCell: { class: ['tw-p-1 tw-text-center'] },
    weekHeader: { class: ['tw-leading-[normal]', 'tw-text-gray-600 dark:tw-text-white/70', disabledTextCursor] },
    weekNumber: { class: ['tw-text-gray-600 dark:tw-text-white/70', disabledTextCursor] },
    weekday: { class: ['tw-text-gray-500 dark:tw-text-white/60'] },
    dayCell: { class: ['tw-p-1'] },
    weekLabelContainer: {
        class: [
            'tw-inline-flex tw-items-center tw-justify-center',
            'tw-mx-auto',
            'tw-w-8 tw-h-8',
            'tw-rounded-full',
            'tw-border-transparent tw-border',
            disabledTextCursor,
        ],
    },
    dayView: 'tw-w-full tw-my-2',
    day: function (_a) {
        var _b, _c, _d;
        var context = _a.context;
        return ({
            class: [
                'tw-flex tw-items-center tw-justify-center',
                'tw-mx-auto',
                'tw-w-8 tw-h-8',
                'tw-rounded-full',
                'tw-border-transparent tw-border',
                { 'tw-text-primary': context.date.today },
                { 'tw-text-gray-600 dark:tw-text-white/70 tw-bg-transparent': !context.selected && !context.disabled && !context.date.today },
                (_b = {}, _b[primarySelectedClasses] = context.selected && !context.disabled, _b),
                focusRingClasses,
                (_c = {},
                    _c[hoverBgGrayClasses] = !context.selected && !context.disabled,
                    _c['hover:tw-bg-highlight-emphasis'] = context.selected && !context.disabled,
                    _c),
                (_d = {}, _d[disabledTextCursor] = context.disabled, _d),
                { 'tw-cursor-pointer': !context.disabled },
            ],
        });
    },
    monthView: { class: ['tw-my-2'] },
    month: function (_a) {
        var context = _a.context;
        return ({
            class: dateCellClasses(context),
        });
    },
    yearView: { class: ['tw-my-2'] },
    year: function (_a) {
        var context = _a.context;
        return ({
            class: dateCellClasses(context),
        });
    },
    timePicker: {
        class: ['tw-flex', 'tw-justify-center tw-items-center', 'tw-border-t-1', 'tw-border-solid tw-border-gray-200', 'tw-p-2'],
    },
    separatorContainer: { class: [timeUnitContainer] },
    separator: { class: ['tw-text-xl'] },
    hourPicker: { class: [timeUnitContainer] },
    minutePicker: { class: [timeUnitContainer] },
    secondPicker: { class: [timeUnitContainer] },
    ampmPicker: { class: [timeUnitContainer] },
    calendarContainer: 'tw-flex',
    calendar: 'tw-flex-auto tw-border-l first:tw-border-l-0 tw-border-gray-200',
    buttonbar: {
        class: ['tw-flex tw-justify-between tw-items-center', 'tw-py-3 tw-px-0', 'tw-border-t tw-border-gray-200 dark:tw-border-gray-700'],
    },
    pcNextButton: { root: { class: controlButtonClasses }, label: { class: 'tw-sr-only' } },
    pcPrevButton: { root: { class: controlButtonClasses }, label: { class: 'tw-sr-only' } },
    pcIncrementButton: { root: { class: controlButtonClasses }, label: { class: 'tw-sr-only' } },
    pcDecrementButton: { root: { class: controlButtonClasses }, label: { class: 'tw-sr-only' } },
    transition: {
        enterFromClass: 'tw-opacity-0 tw-scale-y-[0.8]',
        enterActiveClass: 'tw-transition-[transform,opacity] tw-duration-[120ms] tw-ease-[cubic-bezier(0,0,0.2,1)]',
        leaveActiveClass: 'tw-transition-opacity tw-duration-100 tw-ease-linear',
        leaveToClass: 'tw-opacity-0',
    },
};
